import React from "react";
import { createRoot } from "react-dom/client";
import "./application/sentry";

import "./index.css";

import AppConnected from "./application/app";

const root = createRoot(document.getElementById("appContent"));
root.render(
    <React.StrictMode>
        <AppConnected />
    </React.StrictMode>
);
